export const Assets = {
    warning: require("../../assets/images/ic_60_warning@3x.png"),
    lawChatGraphics: require("../../assets/images/img_law_chat@3x.png"),
};
